import { render, staticRenderFns } from "./CopyGroupModal.vue?vue&type=template&id=c01a4540"
import script from "./CopyGroupModal.vue?vue&type=script&lang=js"
export * from "./CopyGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports